import axios from 'axios';




export const getPincodeData = async (pinCode) =>{

let url = `${process.env.REACT_APP_API_URL}my_api/get-postcode-information/`;
try {
    const response = await axios.get(url, {
      params: {
        postal_code: pinCode
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching postcode information:', error);
    throw error; 
  }


}

export const checkGstUNique = async(gstNo) =>{
let url = `${process.env.REACT_APP_API_URL}useraccount/check-gst-onboarding/`;
try {
    const response = await axios.post(url, {
       gst: gstNo 
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching postcode information:', error);
    throw error; 
  }


}

export const checkEmailUnique = async (email) =>{
let url = `${process.env.REACT_APP_API_URL}useraccount/check-email-onboarding/`;
try {
    const response = await axios.post(url, {
       email: email 
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching postcode information:', error);
    throw error; 
  }
}
export const CheckPhoneUnique = async (number)=>{
 let url = `${process.env.REACT_APP_API_URL}useraccount/check-mobile`;
try {
    const response = await axios.post(url, {
       mobile_number: number 
    });
    return response.data;
  } catch (error) {
    console.error('Error in mobile verification', error);
    return false
  } 
}


export const required_field_data_response = (clientType)=>{


switch (clientType) {
  case "LLP":
  case "Private Limited":
  case "Public Limited":
    return ["panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
  
  case "Partnership":
  case "Sole Proprietorship":
    return ["panCard"]
    
  default:
    return []
}

}

export const send_otp_mobile = async (mobileNumber)=>{

let url = `${process.env.REACT_APP_API_URL}useraccount/SentOtpForMobile/`;
try {
    const response = await axios.post(url, {
       mobile_number: mobileNumber 
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
}
export const send_otp_email = async (emailId)=>{
let url = `${process.env.REACT_APP_API_URL}useraccount/client-email-verify/`;
try {
    const response = await axios.post(url, {
       email: emailId 
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
}

export const verify_email = async(emailId,otp)=>{
let url = `${process.env.REACT_APP_API_URL}useraccount/client-otp-verify/`;
try {
    const response = await axios.post(url, {
       email:emailId,
       otp:otp
    });
    return response.data;
  } catch (error) {
    return false
  }

}



export const verify_mobile = async(mobileNumber,otp)=>{

let url = `${process.env.REACT_APP_API_URL}useraccount/VerifyRegistrations/`;
try {
    const response = await axios.post(url, {
       mobile_number:mobileNumber,
       otp:otp
    });
    console.log("ceckkk resp",response);
    if(response?.data?.message == "otp not verify"){
      return false;
    }
    return response.data;
  } catch (error) {
    return false;
  }

}



export const submitForm = async(data)=>{



const ob_send_data =   {
  name_of_the_company :"companyName",
    company_type : "companyType",
    name_of_business:"natureOfBusiness", 
    date_of_establishment :"dateOfEstablishment",
    gstin: "gstin", 
    pan_no: "panNo", 
    name_of_account_user:"accountUserName", 
    designation_of_account_user: "accountUserDesignation",
    mobile_number_of_account_user:"accountUserMobile", 
    email_address_of_Account_user :"accountUserEmail", 
    register_address :"registeredAddress",
    register_pin :"registeredPincode",
    register_city:"registeredCity", 
    register_state:"registeredState",
    register_country :"registeredCountry",
    business_address :"businessAddress",
    business_pin:"businessPincode",
    
    business_city:"businessCity", 
    business_state :"businessState",
    business_country :"businessCountry",
    ware_house_address :"warehouseAddress",
    ware_house_pin:"warehousePincode",
    ware_house_city :"warehouseCity",
    ware_house_state :"warehouseState",
    ware_house_country:"warehouseCountry",
    stor_address :"storeAddress",
    store_house_pin :"storePincode",
    store_city :"storeCity",
    store_state :"storeState",
    store_country :"storeCountry",
    comapny_website_url:"websiteUrl",
    pan_card_file :"panCard",
    gstin_certificate_file:"gstinCertificate", 
    company_certificate_of_incorporation:"incorporationCertificate" ,
    company_authorisation_certificate_for_account_user:"authorizationLetter", 
    company_msme_certificate :"msmeCertificate",
    aadhar_car:"aadharCard"
  }

const form_data = new FormData()

for (const key in ob_send_data) {
  if (ob_send_data.hasOwnProperty(key)) {
    form_data.append(key, data[ob_send_data[key]]);
  }
}

let url = `${process.env.REACT_APP_API_URL}useraccount/client-onboard-api`;
try {
    const response = await axios.post(url, form_data);
    return response.data;
  } catch (error) {
    return false
  }

}



